export default (theme) => ({
    '@keyframes cylonSweep': {
        '0%, 100%': { backgroundPosition: '150% center' },
        '50%': { backgroundPosition: '-50% center' },
    },
    container: {
        alignItems: 'center',
        display: 'flex',
        height: '100%',
        justifyContent: 'flex-start',
        position: 'relative',
        width: '100%',
    },
    loader: {
        flexShrink: 0,
    },
    phraseRow: {
        alignItems: 'center',
        display: 'flex',
        height: '100%',
        justifyContent: 'flex-start',
        width: '100%',
    },
    phrase: {
        ...theme.typography.caption,
        alignItems: 'center',
        color: theme.colors.textLight.primary,
        display: 'inline-flex',
        gap: 6,
        justifyContent: 'flex-start',
        overflow: 'hidden',
        textAlign: 'left',
        verticalAlign: 'top',
        width: '100%',
    },
    phraseDone: {
        color: theme.colors.textLight.jadeAccessible,
        textAlign: 'center',
    },
    phraseLoading: {
        '& $phraseText': {
            background: `linear-gradient(90deg, ${theme.colors.textLight.primary} 35%, ${theme.colors.primary.white} 50%, ${theme.colors.textLight.primary} 65%)`,
            backgroundClip: 'text',
            backgroundSize: '200% 100%',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            animation: '$cylonSweep 2.5s ease-in-out infinite',
            color: 'transparent',
            overflow: 'hidden',
            paddingTop: 4,
            width: '100%',
        },
    },
    phraseText: {
        display: '-webkit-box',
        minWidth: 0,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        WebkitBoxOrient: 'vertical',
        WebkitLineClamp: 2,
        whiteSpace: 'normal',
        width: '100%',
    },
});
